import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { C } from '../constants';

const COLORS = ['#c9714a','#5dade2','#27ae60','#9b59b6','#e67e22','#e74c3c','#1abc9c','#2980b9'];

function Avatar({ profile, size = 36 }) {
  const char    = profile?.avatar || profile?.name?.charAt(0)?.toUpperCase() || '?';
  const isEmoji = char.length > 1 || char.charCodeAt(0) > 127;
  const color   = COLORS[(profile?.id || 0) % COLORS.length];
  return (
    <div style={{ width:size, height:size, borderRadius:'50%', background: isEmoji ? C.bgCard : color, display:'flex', alignItems:'center', justifyContent:'center', fontSize: isEmoji ? size*0.55+'px' : size*0.42+'px', color:'#fff', fontWeight:'700', flexShrink:0, border:`2px solid rgba(255,255,255,0.12)`, fontFamily:'Inter, sans-serif' }}>
      {char}
    </div>
  );
}

export default function UserMenu({ user, profile, profiles, isMobile, onSwitchProfile, onAdmin, onLogout, onInstall, installPrompt }) {
  const [open, setOpen]   = useState(false);
  const [pos, setPos]     = useState({ top:0, right:0 });
  const btnRef = useRef(null);

  // Calcular posición fixed al abrir
  const toggle = () => {
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 8, right: window.innerWidth - rect.right });
    }
    setOpen(o => !o);
  };

  useEffect(() => {
    const handler = e => {
      if (btnRef.current && !btnRef.current.contains(e.target) &&
          !document.getElementById('usermenu-dropdown')?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Cerrar al hacer scroll
  useEffect(() => {
    if (!open) return;
    const handler = () => setOpen(false);
    window.addEventListener('scroll', handler, true);
    return () => window.removeEventListener('scroll', handler, true);
  }, [open]);

  const isAdmin    = user?.role === 'admin';
  const isUploader = user?.role === 'uploader';

  const item = (icon, label, onClick, danger) => (
    <button onClick={() => { setOpen(false); onClick(); }}
      style={{ width:'100%', display:'flex', alignItems:'center', gap:'10px', padding:'9px 16px', background:'transparent', border:'none', color: danger ? C.danger : C.text, fontSize:'13px', cursor:'pointer', fontFamily:'Inter, sans-serif', textAlign:'left' }}
      onMouseEnter={e => e.currentTarget.style.background = danger ? C.dangerDim : 'rgba(255,255,255,0.05)'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
      <span style={{ fontSize:'15px', width:'18px', textAlign:'center', flexShrink:0 }}>{icon}</span>
      <span>{label}</span>
    </button>
  );

  const divider = <div style={{ height:'1px', background:C.border, margin:'4px 0' }} />;

  return (
    <>
      {/* Trigger button */}
      <button ref={btnRef} onClick={toggle}
        style={{ display:'flex', alignItems:'center', gap:'8px', background: open ? 'rgba(201,113,74,0.12)' : 'rgba(255,255,255,0.04)', border:`1px solid ${open ? C.accentBorder : 'rgba(255,255,255,0.1)'}`, borderRadius:'24px', padding:'4px 10px 4px 4px', cursor:'pointer', transition:'all 0.15s' }}
        onMouseEnter={e => { if (!open) { e.currentTarget.style.background='rgba(255,255,255,0.07)'; e.currentTarget.style.borderColor='rgba(201,113,74,0.3)'; } }}
        onMouseLeave={e => { if (!open) { e.currentTarget.style.background = open ? 'rgba(201,113,74,0.12)' : 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = open ? C.accentBorder : 'rgba(255,255,255,0.1)'; } }}>
        <Avatar profile={profile} size={28} />
        {!isMobile && (
          <span style={{ color:C.text, fontSize:'13px', fontWeight:'500', fontFamily:'Inter, sans-serif', maxWidth:'90px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {profile?.name || user?.name}
          </span>
        )}
        <span style={{ color:C.textMuted, fontSize:'10px', transition:'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', display:'block' }}>▼</span>
      </button>

      {/* Dropdown — portal en document.body, igual que Netflix */}
      {open && ReactDOM.createPortal(
        <div id="usermenu-dropdown" style={{ position:'fixed', top: pos.top+'px', right: pos.right+'px', minWidth:'210px', background:'rgba(19,12,6,0.98)', border:`1px solid ${C.accentBorder}`, borderRadius:'12px', boxShadow:'0 16px 48px rgba(0,0,0,0.8)', zIndex:9999, overflow:'hidden', backdropFilter:'blur(20px)' }}>
          <div style={{ padding:'14px 16px 10px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
              <Avatar profile={profile} size={38} />
              <div style={{ overflow:'hidden' }}>
                <p style={{ color:C.text, fontSize:'13px', fontWeight:'600', fontFamily:'Inter, sans-serif', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{user?.name}</p>
                <p style={{ color:C.textMuted, fontSize:'11px', fontFamily:'Inter, sans-serif', marginTop:'1px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{user?.email}</p>
              </div>
            </div>
            {profile && (
              <div style={{ marginTop:'10px', padding:'6px 10px', background:'rgba(201,113,74,0.08)', border:`1px solid ${C.accentBorder}`, borderRadius:'8px', display:'flex', alignItems:'center', gap:'8px' }}>
                <Avatar profile={profile} size={20} />
                <span style={{ color:C.accentSoft, fontSize:'12px', fontFamily:'Inter, sans-serif', fontWeight:'500' }}>{profile.name}</span>
                <span style={{ color:C.textDim, fontSize:'10px', marginLeft:'auto', fontFamily:'Inter, sans-serif' }}>activo</span>
              </div>
            )}
          </div>

          {divider}

          {profiles?.length > 0 && item('↔', 'Cambiar perfil', onSwitchProfile)}
          {(isAdmin || isUploader) && item(isAdmin ? '⚙' : '⬆', isAdmin ? 'Panel admin' : 'Subir contenido', onAdmin)}
          {installPrompt && item('⬇', 'Instalar app', onInstall)}

          {divider}

          {item('⎋', 'Cerrar sesión', onLogout, true)}
        </div>,
        document.body
      )}
    </>
  );
}
